<template>
  <div>
    <b-row v-if="!gridMode">
      <!-- Minhas Pendências (Full Row Mode) -->
      <b-col lg="6" class="mb-4">
        <b-card no-body class="h-100">
          <b-card-body>
            <h5 class="card-title">
              <i class="fas fa-tasks"></i>
              Minhas Pendências
            </h5>

            <div v-if="loading" class="text-center">
              <b-spinner small></b-spinner>
              <span class="ml-2">Carregando...</span>
            </div>
            <div
              v-else-if="myPendencies.length === 0"
              class="text-muted text-center"
            >
              <i class="fas fa-check-circle"></i>
              Nenhuma pendência encontrada
            </div>
            <div v-else>
              <div class="mb-3">
                <div>
                  <b-badge variant="primary" class="mr-2">
                    Total: {{ myPendencies.length }}
                  </b-badge>
                  <small class="text-muted">pendências aguardando ação</small>
                </div>
              </div>

              <div class="pendencies-list-container">
                <div class="pendencies-header">
                  <div class="row-content">
                    <div class="protocol-section header-label">PROTOCOLO</div>
                    <div class="due-date-section header-label">PRAZO</div>
                    <div class="status-section header-label">STATUS</div>
                    <div class="actions-section header-label">AÇÕES</div>
                  </div>
                </div>
                <div class="pendencies-scroll" @scroll="handleScrollMy">
                  <div class="pendencies-list">
                    <div
                      v-for="event in visibleMyPendencies"
                      :key="event._id"
                      class="pendency-row"
                      @click="openPendency(event)"
                    >
                      <div class="row-content">
                        <div class="protocol-section">
                          <strong class="protocol-link">{{
                            event.complaint.protocol
                          }}</strong>
                        </div>

                        <div class="due-date-section">
                          <span v-if="dueDate(event)" class="date-text">
                            {{ dueDate(event) | date }}
                          </span>
                          <span v-else class="text-muted">-</span>
                        </div>

                        <div class="status-section">
                          <i
                            class="fas fa-calendar"
                            :class="getEventDueClass(event)"
                            :title="getEventDueTitle(event)"
                          />
                        </div>

                        <div class="actions-section">
                          <b-button
                            size="sm"
                            variant="link"
                            class="p-0 action-button"
                            @click="showPendency($event, event)"
                          >
                            <i class="fas fa-eye"></i>
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Demais Pendências (Full Row Mode) -->
      <b-col lg="6" class="mb-4">
        <b-card no-body class="h-100">
          <b-card-body>
            <h5 class="card-title">
              <i class="fas fa-users"></i>
              Demais Pendências
            </h5>

            <div v-if="loading" class="text-center">
              <b-spinner small></b-spinner>
              <span class="ml-2">Carregando...</span>
            </div>
            <div
              v-else-if="otherPendencies.length === 0"
              class="text-muted text-center"
            >
              <i class="fas fa-check-circle"></i>
              Nenhuma pendência encontrada
            </div>
            <div v-else>
              <div class="mb-3">
                <div>
                  <b-badge variant="secondary" class="mr-2">
                    Total: {{ otherPendencies.length }}
                  </b-badge>
                  <small class="text-muted"
                    >pendências de outros usuários</small
                  >
                </div>
              </div>

              <div class="pendencies-list-container">
                <div class="pendencies-header">
                  <div class="row-content">
                    <div class="protocol-section header-label">PROTOCOLO</div>
                    <div class="due-date-section header-label">PRAZO</div>
                    <div class="status-section header-label">STATUS</div>
                    <div class="actions-section header-label">AÇÕES</div>
                  </div>
                </div>
                <div class="pendencies-scroll" @scroll="handleScrollOther">
                  <div class="pendencies-list">
                    <div
                      v-for="event in visibleOtherPendencies"
                      :key="event._id"
                      class="pendency-row"
                      @click="openPendency(event)"
                    >
                      <div class="row-content">
                        <div class="protocol-section">
                          <strong class="protocol-link">{{
                            event.complaint.protocol
                          }}</strong>
                        </div>

                        <div class="due-date-section">
                          <span v-if="dueDate(event)" class="date-text">
                            {{ dueDate(event) | date }}
                          </span>
                          <span v-else class="text-muted">-</span>
                        </div>

                        <div class="status-section">
                          <i
                            class="fas fa-calendar"
                            :class="getEventDueClass(event)"
                            :title="getEventDueTitle(event)"
                          />
                        </div>

                        <div class="actions-section">
                          <b-button
                            size="sm"
                            variant="link"
                            class="p-0 action-button"
                            @click="showPendency($event, event, true)"
                          >
                            <i class="fas fa-eye"></i>
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Grid Mode Rendering (Single Card) -->
    <template v-else>
      <b-card no-body class="h-100 dashboard-card">
        <b-card-body>
          <h5 class="card-title">
            <i
              :class="gridType === 'personal' ? 'fas fa-tasks' : 'fas fa-users'"
            ></i>
            {{
              gridType === "personal"
                ? "Minhas Pendências"
                : "Demais Pendências"
            }}
          </h5>

          <div v-if="loading" class="text-center">
            <b-spinner small></b-spinner>
            <span class="ml-2">Carregando...</span>
          </div>
          <div
            v-else-if="
              (gridType === 'personal' ? myPendencies : otherPendencies)
                .length === 0
            "
            class="text-muted text-center"
          >
            <i class="fas fa-check-circle"></i>
            Nenhuma pendência encontrada
          </div>
          <div v-else>
            <div class="mb-3">
              <div>
                <b-badge
                  :variant="gridType === 'personal' ? 'primary' : 'secondary'"
                  class="mr-2"
                >
                  Total:
                  {{
                    (gridType === "personal" ? myPendencies : otherPendencies)
                      .length
                  }}
                </b-badge>
                <small class="text-muted">
                  {{
                    gridType === "personal"
                      ? "pendências aguardando ação"
                      : "pendências de outros usuários"
                  }}
                </small>
              </div>
            </div>

            <div class="pendencies-list-container">
              <div class="pendencies-header">
                <div class="row-content">
                  <div class="protocol-section header-label">PROTOCOLO</div>
                  <div class="due-date-section header-label">PRAZO</div>
                  <div class="status-section header-label">STATUS</div>
                  <div class="actions-section header-label">AÇÕES</div>
                </div>
              </div>
              <div class="pendencies-scroll" @scroll="handleScrollGrid">
                <div class="pendencies-list">
                  <div
                    v-for="event in gridType === 'personal'
                      ? visibleMyPendencies
                      : visibleOtherPendencies"
                    :key="event._id"
                    class="pendency-row"
                    @click="openPendency(event)"
                  >
                    <div class="row-content">
                      <div class="protocol-section">
                        <strong class="protocol-link">{{
                          event.complaint.protocol
                        }}</strong>
                      </div>

                      <div class="due-date-section">
                        <span v-if="dueDate(event)" class="date-text">
                          {{ dueDate(event) | date }}
                        </span>
                        <span v-else class="text-muted">-</span>
                      </div>

                      <div class="status-section">
                        <i
                          class="fas fa-calendar"
                          :class="getEventDueClass(event)"
                          :title="getEventDueTitle(event)"
                        />
                      </div>

                      <div class="actions-section">
                        <b-button
                          size="sm"
                          variant="link"
                          class="p-0 action-button"
                          @click="
                            showPendency($event, event, gridType === 'other')
                          "
                        >
                          <i class="fas fa-eye"></i>
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </template>

    <!-- Modal para detalhes da pendência -->
    <b-modal
      ref="modal"
      :title="`Movimentação ${modalEvent.number}`"
      size="md"
      ok-only
    >
      <p class="card-text">
        <label><strong>Descrição:</strong></label> {{ modalEvent.description }}
      </p>
      <template
        v-if="modalEvent.pendency && modalEvent.pendency.user && showUser"
      >
        <label>
          <strong>Pendência para: </strong
          >{{
            companyUsers[modalEvent.pendency.user]
              ? companyUsers[modalEvent.pendency.user].name
              : ""
          }}
          {{
            companyUsers[modalEvent.pendency.user]
              ? companyUsers[modalEvent.pendency.user].surname
              : ""
          }}
        </label>
        <br />
      </template>
      <template v-if="modalEvent.task && modalEvent.task.email && showUser">
        <label>
          <strong>Tarefa de terceiros para: </strong>{{ modalEvent.task.email }}
        </label>
        <br />
      </template>
      <label v-if="modalEvent.pendency && modalEvent.pendency.dueDate">
        <strong>Prazo: </strong>{{ modalEvent.pendency.dueDate | date }}
      </label>
      <br />
      <p v-if="modalEvent.user" class="card-text">
        <small class="text-muted">
          <i class="fa fa-calendar-alt" aria-hidden="true"></i>
          {{ modalEvent.createdAt | datetime }} -
          <template v-if="companyUsers[modalEvent.user]">
            <i class="fa fa-user" aria-hidden="true"></i>
            {{ companyUsers[modalEvent.user].name }}
            {{ companyUsers[modalEvent.user].surname }}
          </template>
          <template v-else-if="conformitaUsers[modalEvent.user]">
            <i class="fa fa-user-tie text-info" aria-hidden="true"></i>
            {{ conformitaUsers[modalEvent.user].name }}
            {{ conformitaUsers[modalEvent.user].surname }}
          </template>
        </small>
      </p>
    </b-modal>
  </div>
</template>

<script>
import { getPendencies } from "../../api/events";
import { mapGetters } from "vuex";
import { getCompanyUsers } from "../../api/company";
import { getSystemUsers } from "../../api/user";
import EventType from "../../../../backend/models/EventType.ts";

export default {
  name: "ListPendencies",
  props: {
    company: {
      type: Number,
      default: null,
    },
    gridMode: {
      type: Boolean,
      default: false,
    },
    gridType: {
      type: String,
      default: "personal", // 'personal' ou 'other'
    },
  },
  data() {
    return {
      myPendencies: [],
      otherPendencies: [],
      modalEvent: {
        pendency: {},
      },
      showUser: false,
      companyUsers: {},
      conformitaUsers: {},
      loading: true,
      limitMy: 15,
      limitOther: 15,
    };
  },
  computed: {
    ...mapGetters(["profile"]),
    isMasterUser() {
      return this.profile.role === "root";
    },
    visibleMyPendencies() {
      return this.myPendencies.slice(0, this.limitMy);
    },
    visibleOtherPendencies() {
      return this.otherPendencies.slice(0, this.limitOther);
    },
  },
  async created() {
    await this.fetchPendencies();

    let resp = await getCompanyUsers(this.profile.company);
    this.companyUsers = resp.data.reduce((obj, user) => {
      obj[user["_id"]] = user;
      return obj;
    }, {});

    resp = await getSystemUsers();
    this.conformitaUsers = resp.data.reduce((obj, user) => {
      obj[user["_id"]] = user;
      return obj;
    }, {});
  },
  methods: {
    async fetchPendencies() {
      this.loading = true;
      this.limitMy = 15;
      this.limitOther = 15;
      try {
        let response = await getPendencies(this.company);
        let { myPendencies, otherPendencies } = response.data;

        const sortByDueDate = (a, b) => {
          const dateA = this.dueDate(a);
          const dateB = this.dueDate(b);

          if (!dateA && !dateB) return 0;
          if (!dateA) return 1;
          if (!dateB) return -1;

          return new Date(dateA) - new Date(dateB);
        };

        this.myPendencies = myPendencies.sort(sortByDueDate);
        this.otherPendencies = otherPendencies.sort(sortByDueDate);
      } catch (error) {
        console.error("Error fetching pendencies:", error);
      } finally {
        this.loading = false;
      }
    },
    dueDate(event) {
      if (event.type === EventType.TASK) {
        return event.task.dueDate;
      }
      return event.pendency.dueDate;
    },
    async openPendency(event) {
      this.$router.push(`/denuncias/${event.complaint._id}?event=${event._id}`);
    },
    getEventDueClass(event) {
      const now = new Date().getTime() / 1000;
      const dueDate = new Date(this.dueDate(event)).getTime() / 1000;
      const delta = dueDate - now;

      if (delta < 0) {
        return "text-danger";
      } else if (delta <= 5 * 24 * 60 * 60) {
        return "text-warning";
      } else {
        return "text-success";
      }
    },
    getEventDueTitle(event) {
      const now = new Date().getTime() / 1000;
      const dueDate = new Date(this.dueDate(event)).getTime() / 1000;
      const delta = dueDate - now;

      if (delta < 0) {
        return "Vencida";
      } else if (delta <= 5 * 24 * 60 * 60) {
        return "Vence em menos de 5 dias";
      } else {
        return "À vencer";
      }
    },

    showPendency(evt, pendency, showUser = false) {
      evt.stopPropagation();
      this.modalEvent = pendency;
      this.showUser = showUser;
      this.$refs.modal.show();
    },
    handleScrollMy(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        if (this.limitMy < this.myPendencies.length) {
          this.limitMy += 15;
        }
      }
    },
    handleScrollOther(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        if (this.limitOther < this.otherPendencies.length) {
          this.limitOther += 15;
        }
      }
    },
    handleScrollGrid(event) {
      if (this.gridType === "personal") {
        this.handleScrollMy(event);
      } else {
        this.handleScrollOther(event);
      }
    },
  },
};
</script>

<style scoped>
.h-100 {
  height: 100% !important;
}

.pendencies-list-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  margin-top: 1rem;
}

.pendencies-header {
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.header-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  text-transform: uppercase;
}

.pendencies-scroll {
  max-height: 250px;
  overflow-y: auto;
}

.pendencies-list {
  padding: 0;
}

.pendency-row {
  border-bottom: 1px solid #f1f3f4;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.pendency-row:hover {
  background-color: #f8f9fa;
}

.pendency-row:last-child {
  border-bottom: none;
}

.row-content {
  display: grid;
  grid-template-columns: 2fr 1.5fr 0.8fr 0.8fr;
  align-items: center;
  gap: 1rem;
}

.protocol-section,
.due-date-section,
.status-section,
.actions-section {
  display: flex;
  align-items: center;
}

.actions-section {
  justify-content: center;
}

.protocol-link {
  color: #007bff;
  font-weight: 500;
}

.date-text {
  color: #6c757d;
}

.action-button {
  color: #6c757d;
  transition: color 0.2s;
}

.action-button:hover {
  color: #007bff;
}

.card-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #495057;
}

.card-title .fas {
  margin-right: 8px;
}

.card-title .fa-tasks {
  color: #007bff;
}

.card-title .fa-users {
  color: #6c757d;
}

/* Ajustes para os cards */
.card {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-body {
  padding: 1.5rem;
}

/* Responsividade */
@media (max-width: 992px) {
  .row-content {
    grid-template-columns: 1.5fr 1fr 0.8fr 0.8fr;
    gap: 0.5rem;
  }

  .header-label {
    font-size: 0.7rem;
  }
}
</style>
